export default __webpack_public_path__ + "static/media/Avaware_Logo.86d4a3b6.png";